import { Coordinates } from "../../types/MapData";
import type { LatLng } from "leaflet";
import { useMapEvents } from "react-leaflet";

type Props = {
  onMapClick?: (position: Coordinates) => void;
  onMapDoubleClick?: (position: Coordinates) => void;
  onMapRightClick?: (position: Coordinates) => void;
  onMouseOver?: (position: { x: number; y: number }) => void;
  onMouseLeave?: () => void;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
};

export const MapEventHandler = (props: Props) => {
  const {
    onMapClick,
    onMapDoubleClick,
    onMapRightClick,
    onMouseOver,
    onMouseLeave,
    onMouseDown,
    onMouseUp,
  } = props;
  const toCoord = (val: LatLng): Coordinates => {
    return { x: val.lng, y: val.lat };
  };

  useMapEvents({
    click(event) {
      onMapClick?.(toCoord(event.latlng));
    },
    dblclick(event) {
      onMapDoubleClick?.(toCoord(event.latlng));
    },
    contextmenu(event) {
      onMapRightClick?.(toCoord(event.latlng));
    },
    mousemove(event) {
      if (onMouseOver) {
        const point = event.containerPoint;
        onMouseOver({ x: point.x, y: point.y });
      }
    },
    mouseout() {
      onMouseLeave?.();
    },
    mousedown() {
      onMouseDown?.();
    },
    mouseup() {
      onMouseUp?.();
    },
  });
  return null;
};
